<template>
  <div>
    <b-btn
      class="btn-primary btn-sm"
      @click="abrirCadastroAtividade"
    >
      <font-awesome-icon :icon="faPlus" />
      Nova atividade
    </b-btn>
    <b-modal
      ref="modalCadastroAtividade"
      title="Cadastre uma nova atividade"
      size="md"
      :footer-class="'custom-footer-class'"
      no-close-on-backdrop
    >
      <b-form
        @submit.prevent="criarNovaTarefa"
      >
        <!-- Prazo -->
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label="Data e hora de início"
              label-for="StartDateAgendada"
            >
              <input
                id="StartDateAgendada"
                v-model="novaAtividade.startDate"
                type="datetime-local"
                class="form-control"
                required
              >
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              label="Data e hora de término"
              label-for="EndDateAgendada"
            >
              <input
                id="EndDateAgendada"
                v-model="novaAtividade.endDate"
                type="datetime-local"
                class="form-control"
                required
              >
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Tipo de atividade -->
        <b-form-group
          label="Atividade"
          label-for="atividade"
        >
          <b-select
            id="atividade"
            v-model="novaAtividade.atividade"
            :options="atividadeTipos"
            required
          />
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button
          variant="outline-success"
          @click="criarNovaTarefa"
        >
          Salvar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import api from '@/shared/components/atividades-tabela/shared/services/api'
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'

function mapTypeStringToValue(type) {
  if (!type) return ''
  switch (type.toLowerCase()) {
    case 'task':
      return 1
    case 'call':
      return 2
    case 'meeting':
      return 3
    case 'email':
      return 4
    default:
      return ''
  }
}

function mapStatusStringToValue(status) {
  if (!status) return 1
  switch (status.toLowerCase()) {
    case 'pending':
      return 1
    case 'completed':
      return 2
    case 'canceled':
      return 3
    default:
      return 1
  }
}

const OVERDUE_STATUS = 3

function toDateTimeLocalInput(value) {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  const offsetMs = date.getTimezoneOffset() * 60000
  const local = new Date(date.getTime() - offsetMs)
  return local.toISOString().slice(0, 16)
}

function safelyParseDateTime(value) {
  if (!value) return null
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

function toLocalISOStringWithOffset(date) {
  if (!date) return null
  const pad = n => String(n).padStart(2, '0')
  const year = date.getFullYear()
  const month = pad(date.getMonth() + 1)
  const day = pad(date.getDate())
  const hours = pad(date.getHours())
  const minutes = pad(date.getMinutes())
  const seconds = pad(date.getSeconds())
  const tzOffset = -date.getTimezoneOffset()
  const sign = tzOffset >= 0 ? '+' : '-'
  const absOffset = Math.abs(tzOffset)
  const tzHours = pad(Math.floor(absOffset / 60))
  const tzMinutes = pad(absOffset % 60)
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${tzHours}:${tzMinutes}`
}

export default {
  name: 'NovaAtividadeModal',
  components: {
    FontAwesomeIcon,
  },
  props: {
    dealId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      faPlus,
      novaAtividade: {
        titulo: '',
        descricao: '',
        startDate: '',
        endDate: '',
        atividade: '',
        status: 1,
        id: null,
      },
      isEdit: false,
      atividadeTipos: [
        { value: 1, text: 'Tarefa' },
        { value: 2, text: 'Ligação' },
        { value: 3, text: 'E-mail' },
        { value: 4, text: 'Mensagem' },
        { value: 5, text: 'WhatsApp' },
        { value: 6, text: 'Reunião Remota' },
        { value: 7, text: 'Reunião Presencial' },
        { value: 8, text: 'Visita Externa' },
        { value: 9, text: 'Demonstração' },
        { value: 10, text: 'Follow Up' },
      ],
    }
  },
  methods: {
    abrirCadastroAtividade() {
      this.$refs.modalCadastroAtividade.show()
    },
    async criarNovaTarefa() {
      try {
        const startDate = safelyParseDateTime(this.novaAtividade.startDate)
        const endDate = safelyParseDateTime(this.novaAtividade.endDate)

        // Validação: não permitir término anterior ao início
        if (startDate && endDate && endDate < startDate) {
          const msg = 'A data/hora de término não pode ser anterior à data/hora de início.'
          this.$toast({
            component: ToastificationContent,
            props: {
              title: msg,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
          return
        }

        // Required fields validation
        if (!startDate) {
          this.$toast({ component: ToastificationContent, props: { title: 'Preencha a data/hora de início.', icon: 'AlertCircleIcon', variant: 'danger' } })
          return
        }
        if (!endDate) {
          this.$toast({ component: ToastificationContent, props: { title: 'Preencha a data/hora de término.', icon: 'AlertCircleIcon', variant: 'danger' } })
          return
        }
        if (!this.novaAtividade.atividade) {
          this.$toast({ component: ToastificationContent, props: { title: 'Selecione o tipo de atividade.', icon: 'AlertCircleIcon', variant: 'danger' } })
          return
        }

        const status = this.isEdit ? (Number(this.novaAtividade.status) || 1) : this.determineInitialStatus(startDate)
        const payload = {
          Title: this.novaAtividade.titulo,
          Description: this.novaAtividade.descricao || null,
          StartDate: startDate ? toLocalISOStringWithOffset(startDate) : null,
          EndDate: endDate ? toLocalISOStringWithOffset(endDate) : null,
          Status: status,
          Type: Number(this.novaAtividade.atividade) || 1,
        }

        if (this.isEdit && this.novaAtividade.id) {
          // Update expects same fields (without DealId) and likely Id
          payload.Id = this.novaAtividade.id
          await api.updateActivity(payload)
          this.$emit('updated')
        } else {
          payload.DealId = this.dealId
          await api.createActivity(payload)
          this.$emit('created')
        }

        this.resetForm()
        this.$refs.modalCadastroAtividade.hide()
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Erro ao criar/atualizar atividade', e)
      }
    },
    determineInitialStatus(startDate) {
      if (startDate && startDate.getTime() < Date.now()) {
        return OVERDUE_STATUS
      }
      return Number(this.novaAtividade.status) || 1
    },
    openForEdit(atividade) {
      this.isEdit = true
      this.novaAtividade.id = atividade.id
      this.novaAtividade.titulo = atividade.title || ''
      this.novaAtividade.descricao = atividade.description || ''
      this.novaAtividade.startDate = toDateTimeLocalInput(atividade.startDate)
      this.novaAtividade.endDate = toDateTimeLocalInput(atividade.endDate)
      this.novaAtividade.atividade = mapTypeStringToValue(atividade.type)
      this.novaAtividade.status = mapStatusStringToValue(atividade.status)
      this.$refs.modalCadastroAtividade.show()
    },
    resetForm() {
      this.isEdit = false
      this.novaAtividade = {
        titulo: '',
        descricao: '',
        startDate: '',
        endDate: '',
        atividade: '',
        status: 1,
        id: null,
      }
    },
  },
}

</script>
